import type { HttpClient } from '~/api/client';
import { httpClient } from '~/api/client';
import type { DisplayCategoryTree } from '~/api/model';

// Response 타입 (Zod Model 재사용 — OAISchema 금지, api-typegen §0)
type CategoryTreeResponse = DisplayCategoryTree;

export type VendorCategoryParams = {
  ancestorId?: number;
  vendorId?: number;
};

export interface CategoryDataSource {
  getCategoryTree(): Promise<CategoryTreeResponse>;
  getCategoryDescendants(
    displayCategoryId: number,
  ): Promise<CategoryTreeResponse>;
  getVendorCategories(
    params: VendorCategoryParams,
  ): Promise<CategoryTreeResponse>;
}

export class CategoryDataSourceImpl implements CategoryDataSource {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly client: HttpClient = httpClient) {}

  async getCategoryTree() {
    return this.client.request<CategoryTreeResponse>({
      url: '/api/market-place/v1/display-categories',
      method: 'get',
    });
  }

  async getCategoryDescendants(displayCategoryId: number) {
    return this.client.request<CategoryTreeResponse>({
      url: `/api/market-place/v1/display-categories/${displayCategoryId}/descendants`,
      method: 'get',
    });
  }

  async getVendorCategories(params: VendorCategoryParams) {
    return this.client.request<CategoryTreeResponse>({
      url: '/api/market-place/v1/display-categories/vendor',
      method: 'get',
      params: { ...params },
    });
  }
}

export const categoryDataSource = new CategoryDataSourceImpl();
